export default "__VITE_ASSET__BZ$n$wZq__"